<div class="container">
  <div class="option" *ngFor="let option of options" [class.selected]="option.value === localFormControl.value" (click)="selectOption(option.value)">
    <fa-icon icon="check" size="sm" class="selected-icon"></fa-icon>
    <span>{{ option.label }}</span>
  </div>
</div>
